module.exports = __webpack_public_path__ + "img/root.877eaa56.svg";